import { useTranslation } from 'react-i18next';
import { Header } from '../components/header';
import style from './style.module.scss';

export function Legal({ page }) {
    const { t } = useTranslation();

    const data = t(`legal.${page}`, { returnObjects: true });

    const renderList = () => {
        return (
            <>
            {data.sections.map((section, i) => (
                        <div
                            key={i}
                            className={style['legal__section']}
                        >
                            <h2>{section.title}</h2>

                            {section.content && (
                                <p>{section.content}</p>
                            )}

                            {!!section.items?.length && (
                                <ul>
                                    {section.items.map((item, j) => (
                                        <li key={j}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
            </>
        )
    }

    return (
        <>
            <Header />

            <main className={`container section ${style['legal']}`}>
                <div className={style['legal__header']}>
                    <h1>{data.theme}</h1>

                    <p className={style['legal__date']}>
                        {t('legal.effectiveDate')}
                    </p>

                    <p>{data.intro}</p>
                </div>

                <div className={style['legal__sections']}>
                    {renderList()}
                </div>
            </main>
        </>
    );
}